import styled from 'styled-components'
import { Colors, Spacing } from 'cio-design-library/design-tokens'
import Typography, { FontWeights } from 'builder/styles/typography'
import Media from 'builder/styles/media'
import Icon24 from 'builder/components/Icon'

export const CardContainer = styled.div<{ gridCount: number }>`
  display: grid;
  grid-template-rows: ${props => `repeat(${props.gridCount}, 1fr)`};
  width: 520px;
  gap: ${Spacing['2XS']};

  ${Media.Phone`
    width: 311px;
  `}
`

export const Card = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: ${Colors.Neutral5};
  border-radius: 6px;
  padding: ${Spacing.S};
  gap: ${Spacing.XS};

  ${Media.AboveTablet`
  &:hover {
    cursor: pointer;
    background-color: ${Colors.Blue10};
  }
`}
`

export const CardTitleWrapper = styled.div``

export const CardTitle = styled.p`
  ${FontWeights.Medium}
  ${Typography.Body}

  ${Media.AboveTablet`
    ${Card}:hover & {
      color: ${Colors.Blue50};
    }
  `}
`

export const CreateWithAICard = styled(Card)`
  ${Media.AboveTablet`
    &:hover {
      background-color: ${Colors.Indigo10}; // Different background color for AI resume card hover
    }
  `}
`

export const SpinnerWrapper = styled.div`
  margin-left: auto;
  height: 24px;
  width: 24px;
  & > div {
    width: inherit;
    height: inherit;
  }
`

export const IconWrapper = styled.div`
  margin-left: auto;

  ${Media.AboveTablet`
    ${Card}:hover & {
      svg path {
        fill: ${Colors.Blue50};
      }
    }
  `}
`

export const CreateWithAIArrowIcon = styled(IconWrapper)`
  ${Media.AboveTablet`
    ${Card}:hover & {
      svg path {
        fill: ${Colors.Indigo50};
      }
    }
  `}
`
export const ImageWrapper = styled.div``

export const Image = styled.img`
  width: 32px;
  height: 32px;
`

export const CreateWithAICardTitle = styled(CardTitle)`
  margin-bottom: 0px;

  ${Media.AboveTablet`
    ${Card}:hover & {
      color: ${Colors.Indigo60};
    }
  `}
`

export const CardTitleContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
`

export const AIPoweredBadge = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 28px;
  height: 20px;
  padding: 0 4px;
  border-radius: 4px;
  background: rgba(219, 222, 255, 0.5);
  color: ${Colors.Indigo60};
`

export const AIStarImg = styled.img``

export const ArrowIcon = styled(Icon24.ToggleArrow)`
  color: ${Colors.Neutral40};
`
